// removed by extract-text-webpack-plugin
module.exports = {"block-link":"src-components-SecondaryNav----SecondaryNav-module---block-link---rG7zg","text":"src-components-SecondaryNav----SecondaryNav-module---text---182ZC","icon-wrap":"src-components-SecondaryNav----SecondaryNav-module---icon-wrap---NDME8","counter":"src-components-SecondaryNav----SecondaryNav-module---counter---lyo3_","icon":"src-components-SecondaryNav----SecondaryNav-module---icon---3GiPV","br":"src-components-SecondaryNav----SecondaryNav-module---br---2TXA9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SecondaryNav/SecondaryNav.module.scss
// module id = 1206
// module chunks = 114276838955818